<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6">
          <h5>Manage Tuition Attendance</h5>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <!-- Filters -->
        <div class="row mb-3">
          <!-- Program Filter -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedProgramId"
              placeholder="Select Program"
              show-search
              style="width: 100%"
              :filter-option="filterOption"
              @change="handleProgramChange"
            >
              <a-select-option v-for="p in programs" :key="p.id" :value="p.id">
                {{ p.name }}
                <small class="text-muted" v-if="p.code">({{ p.code }})</small>
              </a-select-option>
            </a-select>
          </div>
          <!-- Tuition Session -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedTuitionSessionId"
              placeholder="Select Tuition Session"
              style="width: 100%"
              :disabled="!selectedProgramId"
              @change="handleSessionChange"
            >
              <a-select-option v-for="s in tuitionSessions" :key="s.id" :value="s.id">
                {{ s.name }}
              </a-select-option>
            </a-select>
          </div>
          <!-- Date -->
          <div class="col-md-3 col-12 mb-2">
            <a-date-picker
              size="large"
              style="width: 100%"
              v-model="selectedDate"
              :format="dateFormat"
              :disabled-date="disabledDate"
              @change="handleDateChange"
            />
          </div>
        </div>

        <!-- Manage Attendance Table Component -->
        <div class="card">
          <div class="card-body">
            <a-spin :spinning="loading">
              <manage-attendance-table
                v-if="attendanceData && Object.keys(attendanceData).length > 0"
                :attendanceData="attendanceData"
                :attendanceDate="moment(selectedDate).format('YYYY-MM-DD')"
                :additionalData="{ tuition_session_id: selectedTuitionSessionId }"
                apiEndpoint="/api/tuition/attendance"
                moduleType="tuition"
                :rolesetting="pagepermission"
                @submitted="handleAttendanceSubmitted"
              />
              <div v-else-if="!loading" class="text-center py-5">
                <span class="text-muted">Select a tuition session and date to view attendance</span>
              </div>
            </a-spin>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ManageAttendanceTable from '@/components/attendance/ManageTable/index'

export default {
  name: 'TuitionManageAttendanceView',
  components: {
    ManageAttendanceTable,
  },
  beforeMount() {
    this.$roleutility.checkpermission('tuition-manage-attendance', 22).then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  data() {
    return {
      loading: false,
      dateFormat: 'DD-MM-YYYY',

      programs: [],
      tuitionSessions: [],
      selectedProgramId: undefined,
      selectedTuitionSessionId: undefined,
      selectedDate: moment(),

      attendanceData: null,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
        approvable: false,
      },
    }
  },
  mounted() {
    this.fetchPrograms()
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current && current > moment().endOf('day')
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    fetchPrograms() {
      this.$http.get('/api/tuition/programs')
        .then(({ data }) => {
          this.programs = data.data || data
        })
    },
    handleProgramChange(value) {
      this.selectedProgramId = value
      this.selectedTuitionSessionId = undefined
      this.tuitionSessions = []
      this.attendanceData = null

      if (value) {
        this.$http.get(`/api/tuition/programs/${value}/sessions`)
          .then(({ data }) => {
            this.tuitionSessions = data.data || data
          })
      }
    },
    handleSessionChange() {
      if (this.selectedTuitionSessionId && this.selectedDate) {
        this.fetchAttendance()
      }
    },
    handleDateChange() {
      if (this.selectedTuitionSessionId && this.selectedDate) {
        this.fetchAttendance()
      }
    },
    fetchAttendance() {
      if (!this.selectedTuitionSessionId || !this.selectedDate) {
        this.$message.warning('Please select a tuition session and a date.')
        return
      }
      this.loading = true
      const params = {
        tuition_session_id: this.selectedTuitionSessionId,
        date: moment(this.selectedDate).format('YYYY-MM-DD'),
      }
      this.$http.get('/api/tuition/attendance/data', { params })
        .then(({ data }) => {
          this.attendanceData = data.data || data
        })
        .catch(error => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleAttendanceSubmitted() {
      this.fetchAttendance()
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
